import { render, staticRenderFns } from "./campaignAttachments.vue?vue&type=template&id=7e15c56a&scoped=true&"
import script from "./campaignAttachments.vue?vue&type=script&lang=js&"
export * from "./campaignAttachments.vue?vue&type=script&lang=js&"
import style0 from "./campaignAttachments.vue?vue&type=style&index=0&id=7e15c56a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e15c56a",
  null
  
)

export default component.exports